export default "__VITE_ASSET__01941a0d__"